// Bmob.initialize(
//   "a36988e7ead3b070008c78aaf337b3ef",
//   "751c6674c4425b5a8b524d8a59ccffad"
// ); //2.0以下

Bmob.initialize("d99e8ce57ab6e528", "131412"); //2.0以上

// 默认用户id
const defultUserId = "2ebc9ccf83";

// 注册
export function register(userInfo = {}) {
  return new Promise(function(resolve, reject) {
    let params = {
      username: userInfo.username,
      password: userInfo.password,
      email: userInfo.email
    };
    Bmob.User.register(params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
}

// 登录
export function login(userInfo = {}) {
  return new Promise(function(resolve, reject) {
    Bmob.User.login(userInfo.username, userInfo.password)
      .then(user => {
        if (!user.emailVerified) {
          resolve({
            code: "001",
            email: user.email
          });
          return;
        }
        resolve({
          code: "000",
          avatar: user.avatar,
          userId: user.objectId
        });
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
}

// 退出登录
export function bmobLogout() {
  return new Promise(function(resolve, reject) {
    try {
      Bmob.User.logout();
      resolve({
        code: "000",
        message: "登出成功"
      });
    } catch (error) {
      reject({
        code: "001",
        message: "登出失败"
      });
    }
  });
}

// 重置查询密码
export function resetPwd(payload) {
  return new Promise(function(resolve, reject) {
    Bmob.requestPasswordReset(payload)
      .then(res => {
        resolve({
          code: "000",
          message: "发送成功"
        });
      })
      .catch(err => {
        console.error(err);
        reject({
          code: "001",
          message: "重置错误"
        });
      });
  });
}

// 判断是否登录，获取当前登录的用户
export function currentUser() {
  return new Promise(function(resolve, reject) {
    var currentUser = Bmob.User.current();
    if (currentUser) {
      resolve(currentUser);
    } else {
      reject({
        code: "001",
        message: "未登录"
      });
    }
  });
}

// 查找文章列表，可以带参数
export function queryArticleList(config = {}) {
  let pageData = config.pageData;
  return new Promise(function(resolve, reject) {
    const table = "article_list";
    //分页
    const query = Bmob.Query(table);
    query.limit(pageData.pageNum);
    query.skip((pageData.currentPage - 1) * pageData.pageNum);

    //倒序排
    query.order("-updatedAt");

    //分类条件
    if (pageData.col) {
      query.equalTo("col", "==", pageData.col);
    }

    //标签条件
    if (pageData.tags) {
      // 模糊查询只有VIP可用。。。。
      // query.equalTo("tags", "==", { $regex: "/" + pageData.tags + "/" });
      // query.equalTo("tags", "==", { $regex: "" + pageData.tags + ".*" });
    }

    // 组合条件
    if (pageData.objectIdAry) {
      query.containedIn("objectId", objectIdAry);
    }

    //用户id条件
    query.equalTo("userId", "==", config.userId || defultUserId);

    //查询指定字段减少数据量消耗
    query.select(
      "col",
      "createdAt",
      "intro",
      "mainTitle",
      "objectId",
      "original",
      "tags",
      "updatedAt",
      "userId"
    );

    query
      .find()
      .then(async result => {
        let articleList = [];
        for (let i = 0; i < result.length; i++) {
          let object = result[i];
          object.tags = object.tags.split("，");
          object.ID = result[i].objectId;
          object.date = result[i].createdAt;
          object.updateDate = result[i].updatedAt;
          articleList.push(object);
        }
        //统计总数
        const totalRes = await getUserArticleNumber({ userId: config.userId });
        let newData = {
          articleList,
          count: totalRes[0] ? totalRes[0]._count : 0
        };
        resolve(newData);
      })
      .catch(err => {
        console.error(err);
        console.log("err", err);
        reject("文章加载失败");
      });
  });
}

// 统计所有文章数量
export function getUserArticleNumber(config = {}) {
  return new Promise(function(resolve, reject) {
    const table = "article_list";
    const query = Bmob.Query(table);
    query.equalTo("userId", "==", config.userId || defultUserId);

    //查询指定字段减少数据量消耗
    query.statTo("groupby", "userId");
    query.statTo("groupcount", "userId");
    query
      .find()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error(err);
        reject("统计所有文章数量获取失败");
      });
  });
}

// 统计所有文章字数
export function getArticleTotalNumber(config = {}) {
  return new Promise(function(resolve, reject) {
    const table = "article_list";
    const query = Bmob.Query(table);
    if (config.col) {
      query.equalTo("col", "==", config.col);
    }
    query.equalTo("userId", "==", config.userId || defultUserId);

    //查询指定字段减少数据量消耗
    query.statTo("sum", "wordCount");
    query
      .find()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error(err);
        reject("字数统计获取失败");
      });
  });
}

// 统计所有文章的分类和每项分类总数
export function getTotalCategories(config = {}) {
  return new Promise(function(resolve, reject) {
    const table = "article_list";
    const query = Bmob.Query(table);
    if (config.col) {
      query.equalTo("col", "==", config.col);
    }
    query.equalTo("userId", "==", config.userId || defultUserId);
    //查询指定字段减少数据量消耗
    query.statTo("groupby", "col");
    query.statTo("groupcount", "col");
    query
      .find()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error(err);
        reject("统计所有文章分类获取失败");
      });
  });
}

// 查找文章，带文章ID，带用户头像
export function queryOneArticle(articleId) {
  return new Promise(function(resolve, reject) {
    const table = "article_list";
    const query = Bmob.Query(table);
    query
      .get(articleId)
      .then(result => {
        let object = result;
        object.tags = object.tags.split("，");
        object.ID = result.objectId;
        object.date = result.updatedAt;
        resolve(object);
      })
      .catch(err => {
        console.error(err);
        reject("文章不存在或已删除！");
      });
  });
}

// 查找草稿箱列表，可以带参数
export function queryDrafteList(config = {}) {
  let pageData = config.pageData;
  return new Promise(function(resolve, reject) {
    const table = "article_draft";
    //分页
    const query = Bmob.Query(table);
    query.limit(pageData.pageNum);
    query.skip((pageData.currentPage - 1) * pageData.pageNum);
    //倒序排
    query.order("-updatedAt");

    //用户id条件
    query.equalTo("userId", "==", config.userId || defultUserId);

    //查询指定字段减少数据量消耗
    query.select(
      "col",
      "createdAt",
      "intro",
      "mainTitle",
      "objectId",
      "original",
      "tags",
      "updatedAt",
      "userId"
    );

    query
      .find()
      .then(async result => {
        let articleList = [];
        for (let i = 0; i < result.length; i++) {
          let object = result[i];
          object.tags = object.tags.split("，");
          object.ID = result[i].objectId;
          object.date = result[i].updatedAt;
          articleList.push(object);
        }
        //统计总数
        const totalRes = await getUserDrafteNumber({ userId: config.userId });
        let newData = {
          articleList,
          count: totalRes[0] ? totalRes[0]._count : 0
        };
        resolve(newData);
      })
      .catch(err => {
        console.error(err);
        reject("草稿箱加载失败");
      });
  });
}

// 统计所有草稿文章数量
export function getUserDrafteNumber(config = {}) {
  return new Promise(function(resolve, reject) {
    const table = "article_draft";
    const query = Bmob.Query(table);
    query.equalTo("userId", "==", config.userId || defultUserId);

    //查询指定字段减少数据量消耗
    query.statTo("groupby", "userId");
    query.statTo("groupcount", "userId");
    query
      .find()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error(err);
        reject("统计所有草稿文章数量获取失败");
      });
  });
}

// 查找草稿箱，带文章ID
export function queryOneDraft(draftId) {
  return new Promise(function(resolve, reject) {
    const table = "article_draft";
    const query = Bmob.Query(table);
    query
      .get(draftId)
      .then(result => {
        let object = result;
        object.tags = object.tags.split("，");
        object.ID = result.objectId;
        object.date = result.updatedAt;
        resolve(object);
      })
      .catch(err => {
        console.error(err);
        reject("草稿加载失败");
      });
  });
}

// 新增/修改文章
export function pushArticle(articleObj) {
  return new Promise(function(resolve, reject) {
    // 通过objectId判断是新文章还是更新文章
    if (!articleObj.objectId) {
      //创建类和实例
      const table = "article_list";
      const query = Bmob.Query(table);
      query
        .save(articleObj)
        .then(result => {
          // 添加成功
          resolve(result);
        })
        .catch(err => {
          console.error(err);
          // 添加失败
          reject("添加文章失败");
        });
    } else {
      const table = "article_list";
      const query = Bmob.Query(table);
      query.set("id", articleObj.objectId);
      delete articleObj.objectId;
      query
        .save(articleObj)
        .then(result => {
          resolve("文章更新成功");
        })
        .catch(err => {
          console.error(err);
          reject("文章更新失败");
        });
    }
  });
}

// 设置文章浏览量
export function addArticleView(params) {
  return new Promise(function(resolve, reject) {
    const table = "article_list";
    const query = Bmob.Query(table);
    query.set("id", params.objectId);
    query.set("view", params.view);
    query
      .save()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
}

// 新增/修改草稿箱
export function pushDraft(articleObj) {
  return new Promise(function(resolve, reject) {
    //创建类和实例
    if (!articleObj.objectId) {
      const table = "article_draft";
      const query = Bmob.Query(table);
      query
        .save(articleObj)
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          console.error(err);
          reject("添加草稿箱失败");
        });
    } else {
      const table = "article_draft";
      const query = Bmob.Query(table);
      query.set("id", articleObj.objectId);
      delete articleObj.objectId;
      query
        .save(articleObj)
        .then(res => {
          resolve("草稿更新成功");
        })
        .catch(err => {
          console.error(err);
          reject("草稿更新失败");
        });
    }
  });
}

// 清除文章
export function deatroyArticle(articleId) {
  return new Promise(function(resolve, reject) {
    const table = "article_list";
    const query = Bmob.Query(table);
    query
      .get(articleId)
      .then(result => {
        result
          .destroy()
          .then(res => {
            resolve("删除文章成功");
          })
          .catch(err => {
            reject("删除文章失败");
          });
      })
      .catch(err => {
        console.error(err);
        reject("文章加载失败");
      });
  });
}

// 清除草稿
export function deatroyDraft(draftId) {
  return new Promise(function(resolve, reject) {
    const table = "article_draft";
    const query = Bmob.Query(table);
    query
      .get(draftId)
      .then(result => {
        result
          .destroy()
          .then(res => {
            resolve("删除草稿成功");
          })
          .catch(err => {
            reject("删除草稿失败");
          });
      })
      .catch(err => {
        console.error(err);
        reject("草稿加载失败");
      });
  });
}

// 查找某一个用户
export function queryOneUser(userId = defultUserId) {
  return new Promise(function(resolve, reject) {
    const table = "_User";
    //创建查询对象，入口参数是对象类的实例
    const query = Bmob.Query(table);
    query.select("avatar", "showName", "singName");
    //查询单条数据，第一个参数是这条数据的objectId值
    query
      .get(userId)
      .then(result => {
        // 查询成功，调用get方法获取对应属性的值
        resolve(result);
      })
      .catch(err => {
        console.error(err);
        // 查询失败
        reject("用户查找失败");
      });
  });
}

// 更新用户信息
export function updateUserInfo(userId, info) {
  return new Promise(function(resolve, reject) {
    const table = "_User";
    const query = Bmob.Query(table);
    query.set("id", userId);
    query
      .save(info)
      .then(result => {
        resolve(result[0]);
      })
      .catch(err => {
        console.error(err);
        reject("用户信息修改失败");
      });
  });
}

// 保存code
export function saveCode(codeObject) {
  return new Promise(function(resolve, reject) {
    if (!codeObject.objectId) {
      //创建类和实例
      const table = "code_list";
      const query = Bmob.Query(table);
      query
        .save(codeObject)
        .then(result => {
          // 添加成功
          resolve("code添加成功");
        })
        .catch(err => {
          console.error(err);
          // 添加失败
          reject("code添加失败");
        });
    } else {
      const table = "code_list";
      const query = Bmob.Query(table);
      query.set("id", codeObject.objectId);
      delete codeObject.objectId;
      query
        .save(codeObject)
        .then(result => {
          resolve("code更新成功");
        })
        .catch(err => {
          console.error(err);
          reject("code更新失败");
        });
    }
  });
}

// 查找用户代码片段列表
export function queryCodeList(config = {}) {
  let pageData = config.pageData;
  return new Promise(function(resolve, reject) {
    const table = "code_list";
    //分页
    const query = Bmob.Query(table);
    query.limit(pageData.pageNum);
    query.skip((pageData.currentPage - 1) * pageData.pageNum);
    //倒序排
    query.order("-updatedAt");

    //用户id条件
    query.equalTo("userId", "==", config.userId || defultUserId);

    //查询指定字段减少数据量消耗
    query.select(
      "avatar",
      "codeTitle",
      "createdAt",
      "intro",
      "label",
      "objectId",
      "updatedAt",
      "userId"
    );

    query
      .find()
      .then(async result => {
        //统计总数
        const totalRes = await getUserCodeNumber({ userId: config.userId });
        let newData = {
          result,
          count: totalRes[0] ? totalRes[0]._count : 0
        };
        resolve(newData);
      })
      .catch(err => {
        console.error(err);
        reject("code加载失败");
      });
  });
}

// 统计所有代码片段数量
export function getUserCodeNumber(config = {}) {
  return new Promise(function(resolve, reject) {
    const table = "code_list";
    const query = Bmob.Query(table);
    query.equalTo("userId", "==", config.userId || defultUserId);

    //查询指定字段减少数据量消耗
    query.statTo("groupby", "userId");
    query.statTo("groupcount", "userId");
    query
      .find()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error(err);
        reject("统计所有代码片段数量获取失败");
      });
  });
}

// 查找某个代码片段
export function queryOneCode(codeId) {
  return new Promise(function(resolve, reject) {
    if (!codeId) {
      return;
    }
    const table = "code_list";
    const query = Bmob.Query(table);
    query
      .get(codeId)
      .then(result => {
        result["codeURL"] = `${location.origin +
          location.pathname}#/code?userId=${result.userId}&snippetId=${
          result.objectId
        }`;
        resolve(Object.assign({}, result, result.atrributes));
      })
      .catch(err => {
        console.error(err);
        reject("code加载失败");
      });
  });
}

// 删除某个代码片段
export function deatroyCode(codeId) {
  return new Promise(function(resolve, reject) {
    const table = "code_list";
    const query = Bmob.Query(table);
    query
      .get(codeId)
      .then(result => {
        result
          .destroy()
          .then(res => {
            resolve("删除code成功");
          })
          .catch(err => {
            console.error(err);
            reject("删除code失败");
          });
      })
      .catch(err => {
        console.error(err);
        reject("code加载失败");
      });
  });
}

// 统计访客数
export function getIpNumber(config = {}) {
  return new Promise(function(resolve, reject) {
    const table = "ip_info";
    const query = Bmob.Query(table);
    query.equalTo("userId", "==", config.userId || defultUserId);

    //查询指定字段减少数据量消耗
    query.statTo("groupby", "userId");
    query.statTo("groupcount", "userId");
    query
      .find()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error(err);
        reject("统计访客数获取失败");
      });
  });
}

// 设置访客信息
export function setIpInfo(params) {
  return new Promise(function(resolve, reject) {
    const table = "ip_info";
    const query = Bmob.Query(table);
    for (const key in params) {
      params[key] && query.set(key, params[key]);
    }
    query
      .save()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/bmob.js